// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReadFilledSvg from "@ant-design/icons-svg/es/asn/ReadFilled";
import AntdIcon from '../components/AntdIcon';

var ReadFilled = function ReadFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReadFilledSvg
  }));
};

ReadFilled.displayName = 'ReadFilled';
export default React.forwardRef(ReadFilled);